/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What thumbnail resolutions are available?`)
};

const es_yt_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué resoluciones de miniatura están disponibles?`)
};

const de_yt_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Thumbnail-Auflösungen sind verfügbar?`)
};

const nl_yt_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke thumbnailresoluties zijn beschikbaar?`)
};

const fr_yt_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelles résolutions de miniature sont disponibles ?`)
};

const it_yt_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali risoluzioni della miniatura sono disponibili?`)
};

const pt_br2_yt_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais resoluções de thumbnail estão disponíveis?`)
};

const pt_yt_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que resoluções de miniatura estão disponíveis?`)
};

const ja_yt_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用できるサムネイルの解像度は？`)
};

const zh_yt_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有哪些可用的缩略图分辨率？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hub_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hub_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hub_faq2_q", locale)
	if (locale === "en") return en_yt_hub_faq2_q(inputs)
	if (locale === "es") return es_yt_hub_faq2_q(inputs)
	if (locale === "de") return de_yt_hub_faq2_q(inputs)
	if (locale === "nl") return nl_yt_hub_faq2_q(inputs)
	if (locale === "fr") return fr_yt_hub_faq2_q(inputs)
	if (locale === "it") return it_yt_hub_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hub_faq2_q(inputs)
	if (locale === "pt") return pt_yt_hub_faq2_q(inputs)
	if (locale === "ja") return ja_yt_hub_faq2_q(inputs)
	return zh_yt_hub_faq2_q(inputs)
};